<template>
  <div class="product-tile">
    <a class="product-tile__image" :href="`//${host}/shop/${slug}`">
      <div v-if="isOnSale" class="product-tile__sale">SALE</div>
      <div v-if="price >= 500 && !isBulky" class="product-tile__free-shipping">FREE DELIVERY</div>
      <img v-if="image" :src="image" :alt="name">
    </a>
    <div class="product-tile__body">
      <a class="product-tile__details" :href="`//${host}/shop/${slug}`">
        <div class="product-tile__brand">{{ brand }}</div>
        <div class="product-tile__name">{{ name }}</div>
        <div v-if="showSku" class="product-tile__name">{{ sku }}</div>
      </a>
      <div class="product-tile__spacer"></div>
      <div class="product-tile__price-container">
        <div class="product-tile__price-wrapper">
          <div class="product-tile__price" v-html="formattedPrice"></div>
          <a class="product-tile__button" :href="`//${host}/shop/${slug}`">View Product</a>
        </div>
        <div class="product-tile__qty" v-if="!hasVariants && price">
          <button @click="decrementQty"><i class="fas fa-minus"></i></button>
          <span>{{ qty }}</span>
          <button @click="$emit('addToCart')"><i class="fas fa-plus"></i></button>
        </div>
      </div>
      <div class="product-tile__add" v-if="!hasVariants && !qty && price" @click="$emit('addToCart')">Add to cart</div>
      <a class="product-tile__add" v-if="!hasVariants && !qty && !price" :href="`//${host}/shop/${slug}`">Request Quote</a>
      <div class="product-tile__remove" v-if="!hasVariants && qty" @click="$emit('removeFromCart')">Remove from cart</div>
      <a class="product-tile__variant" v-if="hasVariants" :href="`//${host}/shop/${slug}`">View options</a>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'product-id',
    'slug',
    'image',
    'brand',
    'name',
    'sku',
    'price',
    'host',
    'qty',
    'sale-price',
    'regular-price',
    'price-html',
    'has-variants',
    'search-priority',
    'is-on-sale',
    'tags',
    'show-sku'
  ],

  computed: {
    // isOnSale () {
    //   return this.salePrice && this.regularPrice
    // },
    
    isBulky () {
      // Check if the product has 'Bulky' tag
      return this.tags.includes('bulky');
    },

    formattedPrice () {
      if (!this.price) return 'Enquire Now'
      if (this.salePrice && this.regularPrice) {
        return `<span>$${Number.parseFloat(this.salePrice).toFixed(2)}</span><del>$${Number.parseFloat(this.regularPrice).toFixed(2)}</del>`
      }
      return `$${Number.parseFloat(this.price).toFixed(2)}`
    }
  },

  filters: {
    currency: function (value) {
      return value.toFixed(2).toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 })
    }
  },

  methods: {
    decrementQty () {
      if (this.qty === 0) {
        return
      } else if (this.qty === 1) {
        this.$emit('removeFromCart')
      } else {
        this.$emit('updateItem', this.productId, this.qty - 1)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/variables';

.product-tile {
  background: #fff;
  color: #411540;
  // cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  text-decoration: none;
  // overflow: hidden;
  position: relative;

  &__sale, &__free-shipping {
    background-color: $pink;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    padding: 5px;
    position: absolute;
    top: 0; 
    left: 0;
    // transform: rotate(-15deg);
  }

  &__free-shipping {
    left: auto;
    right: 0;
    bottom: 0;
    top: auto;
    // transform: rotate(15deg);
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  &__image {
    aspect-ratio: 1/1;
    background-color: #ddd;
    flex-shrink: 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    padding: 15px 0;
  }

  &__details {
    // align-items: center;
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 5px;
  }

  &__brand {
    line-height: 1.5;
    font-size: 15px;
    font-weight: 800;
  }

  &__name {
    line-height: 1.2;
    font-size: 15px;
    margin-bottom: 10px;
  }

  &__price-container {
    display: flex;
    margin-bottom: 15px;
  }

  &__price-wrapper {
    flex-grow: 1;
  }

  &__price {
    color: $pink;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    // margin-bottom: 5px;
    // padding-left: 15px;

    span {
      padding-right: 10px;
    }

    del {
      opacity: 0.5;
      font-size: 0.9em;
    }
  }

  &__qty {
    display: flex;
    align-items: flex-end;
    text-align: right;

    span {
      color: $pink;
      font-size: 20px;
      // font-weight: bold;
      padding: 0 5px 8px;
      vertical-align: middle;
    }

    button {
      border: 0;
      background-color: transparent;
      color: rgba($purple, 0.5);
      cursor: pointer;
      font-size: 20px;
      padding: 5px;
      vertical-align: middle;

      &:hover {
        color: $purple;
        // background-color: rgba($purple, 0.1);
      }
    }
  }

  &__spacer {
    flex-grow: 1;
  }

  &__button {
    color: rgba(#000, 0.6);
    font-size: 16px;
    font-weight: 200;
  }

  &__add, &__remove, &__variant {
    color: #fff !important;
    display: block;
    text-align: center;
    // background-color: $pink;
    background-color: $purple;
    color: #fff;
    cursor: pointer;
    line-height: 40px;
    border-radius: 20px;
    // margin-bottom: 20px;

    &:hover {
      // background-color: rgba($pink, 0.8);
      background-color: rgba($purple, 0.8);
    }
  }

  &__remove {
    opacity: 0.5;
  }

  &__variant {
    background-color: $purple;

    &:hover {
      background-color: rgba($purple, 0.8);
    }    
  }
}
</style>
